'use client';

import { Analytics } from "@vercel/analytics/next";
import { SpeedInsights } from "@vercel/speed-insights/next";
import { useEffect, useState } from 'react';

/**
 * Optimized analytics wrapper that reduces function invocations
 * by detecting bots and conditionally loading analytics
 */
export function AnalyticsWrapper() {
  const [shouldLoad, setShouldLoad] = useState(false);
  
  useEffect(() => {
    // Detect if this is a bot by checking user agent
    const userAgent = navigator.userAgent.toLowerCase();
    
    const botPatterns = [
      'bot', 'crawl', 'spider', 'slurp', 'mediapartners',
      'ahrefsbot', 'semrushbot', 'dotbot', 'mj12bot'
    ];
    
    const isBot = botPatterns.some(pattern => userAgent.includes(pattern));
    
    // Check if we're in production
    const isProduction = process.env.NODE_ENV === 'production';
    
    // Only load analytics for real users in production
    setShouldLoad(isProduction && !isBot);
  }, []);
  
  // Don't render anything on the server or for bots
  if (!shouldLoad) {
    return null;
  }
  
  return (
    <>
      {/* Vercel Analytics - tracks page views and events */}
      <Analytics 
        beforeSend={(event) => {
          // Additional filtering can be done here if needed
          // For example, filter out certain paths or events
          return event;
        }}
      />
      
      {/* Vercel Speed Insights - tracks Core Web Vitals */}
      <SpeedInsights 
        // Sample rate can be adjusted here (default is 100%)
        // sampleRate={0.5} would only track 50% of page loads
      />
    </>
  );
}
